/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Model } from '../models/Model';
import type { ModelAdd } from '../models/ModelAdd';
import type { ModelList } from '../models/ModelList';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ModelsService {
    /**
     * Get models
     * @returns ModelList OK
     * @throws ApiError
     */
    public static listModel(): CancelablePromise<ModelList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/models',
        });
    }
    /**
     * Add models
     * Add model in list
     * @param requestBody Add model
     * @returns Model OK
     * @throws ApiError
     */
    public static modelAdd(
        requestBody?: ModelAdd,
    ): CancelablePromise<Model> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/models',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get model by model_id
     * @param id model_id
     * @returns Model OK
     * @throws ApiError
     */
    public static getModel(
        id: string,
    ): CancelablePromise<Model> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/models/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update model
     * update model by id
     * @param id model_id
     * @param requestBody Update model data
     * @returns Model OK
     * @throws ApiError
     */
    public static updateModel(
        id: string,
        requestBody?: ModelAdd,
    ): CancelablePromise<Model> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/models/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
